import { useMemo } from 'react';
import cn from 'classnames';

export default function Unread({ count, className }: { count: number; className?: string }) {
  const displayCount = useMemo(() => {
    if (count <= 0) {
      return null;
    }

    if (count > 99) {
      return '99+';
    }

    return count;
  }, [count]);

  if (!displayCount) {
    return null;
  }

  return (
    <div
      className={cn(
        'inline-flex items-center justify-center self-center h-5 text-xs leading-none rounded-full bg-red-500 text-white px-1.5 min-w-5',
        className
      )}
    >
      {displayCount}
    </div>
  );
}
